import React, { useState } from 'react'
import { Paper, } from '@mui/material';
import { Button } from '@mui/material';

import FormDialog from '../panel/modal';
import AddStudenetForm from '../form/addStudentForm';
import { useNavigate } from 'react-router-dom';

import ViewStudents from '../table/viewStudents';
import StudentStatus from '../form/studentStatus';
import AchievementForm from '../form/achievmentForm'
import StudentView from '../table/studentView';
import api from '../../API/api';
import Swal from 'sweetalert2';
import StudentTable from './studentTable';

const AddStudent = () => {

    // const navigation = useNavigate();

    const [open, setOpen] = React.useState(false);
    const [openStatus, setOpenStatus] = React.useState(false);
    const [view, setView] = React.useState(false);
    const [achive, setAchive] = useState();
    const [modalData, setModalData] = React.useState();
    const [refresh, setRefresh] = useState(1);

    const refreshData = () => {
        setRefresh(refresh + 1);
    }

    const handleClickOpen = (data) => {
        setOpen(true);
        // console.log(data, 'data for student add');
        setModalData(data)
    };
    const handleStatusModal = (data) => {
        setOpenStatus(true);
        setModalData(data)
    }
    const handleCloseModal = () => {
        setOpenStatus(false);
    }
    function handleViewOpen(data) {
        setView(true)
        // console.log(data, 'cals view');
        setModalData(data)
    }
    function handleViewClose() {
        setView(false)
    }

    const handleClose = () => { setOpen(false); setAchive(false) }

    function handleAchivement(e) {
        setAchive(true)
        setModalData(e)
    }

    function deleteStudent(obj) {
        // console.log(obj, 'data');
        api.deleteStudent(obj).then(res => {
            // console.log(res,'sadbi');
            Swal.fire({
                title: 'Success!',
                text: res.data.message,
                icon: 'success',
                confirmButtonText: 'Ok'
            })
            window.location.reload();
        }).catch(err => {
            // console.log(err);
            Swal.fire({
                title: 'Error!',
                text: 'Something Went Wrong',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        })
    }


    // console.log(modalData, 'modalData');

    return (
        <>
            <div className="row">
                <Paper elevation={3}>
                    <div className="col-12 p-2"></div>

                    <div className="col-12 d-flex justify-content-between p-2">
                        <div></div>
                        <Button variant='contained' onClick={handleClickOpen}>+Add Student</Button>
                    </div>

                    <FormDialog
                        form={<AddStudenetForm handleClose={handleClose} handleClickOpen={handleClickOpen} modalData={modalData} />}
                        title='Add Student' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose}
                    />

                    <FormDialog
                        form={<StudentStatus handleClose={handleCloseModal} handleStatusModal={handleStatusModal} modalData={modalData} refreshData={refreshData} />}
                        title='Student Status' open={openStatus} handleStatusModal={handleStatusModal} handleClose={handleCloseModal} size={'xs'}
                    />
                    <FormDialog
                        form={<StudentView handleClose={handleViewClose} handleClickOpen={handleViewOpen} modalData={modalData} refreshData={refreshData} />}
                        title='Student View' open={view} handleClickOpen={handleViewOpen} handleClose={handleViewClose} size={'lg'}
                    />
                    <FormDialog
                        form={<AchievementForm modalData={modalData} handleClose={handleClose} type="student" edit='no' />}
                        title='Student View' open={achive} handleClickOpen={handleViewOpen} handleClose={handleClose} size={'sm'}
                    />
                </Paper>


                <StudentTable
                    studentModalOpen={handleClickOpen}
                    studentModalClose={handleClose}
                    setModalData={setModalData}
                    handleStatusModal={handleStatusModal}
                    handleViewOpen={handleViewOpen}
                    handleAchivement={handleAchivement}
                    refresh={refresh}
                    deleteStudent={deleteStudent} />

                {/* <Paper>
                    <div className="col-12">
                        <ViewStudents
                            studentModalOpen={handleClickOpen}
                            studentModalClose={handleClose}
                            setModalData={setModalData}
                            handleStatusModal={handleStatusModal}
                            handleViewOpen={handleViewOpen}
                            handleAchivement={handleAchivement}
                            refresh={refresh}
                            deleteStudent={deleteStudent}
                        />
                    </div>
                </Paper> */}
            </div>
        </>
    )
}

export default AddStudent;